import axios from "axios";

import { successHandling } from "../helpers/successHandling";

export const resetTriggeredAlarmsAPI = async (deviceId, t, successfulText) => {
  await axios({
    url: `/api/v2/alarm/trigger/reset-triggered-alarms`,
    method: "POST",
    params: {
      alarm_triggered_device_id: deviceId
    }
  });
  successHandling(t, successfulText);
  return true;
};
